module.exports = __webpack_public_path__ + "static/media/home.01f29836.png";